import { Component, OnInit } from '@angular/core';
import { IAuditChanges } from '../../interfaces/auditchanges';
import { IAuditChangesFilter } from '../../interfaces/auditchanges-filter';
import { IPageResult } from '../../interfaces/page-result';
import { AuditChangesService } from '../../services';

@Component({
  selector: 'auditchanges',
  templateUrl: './auditchanges.component.html',
})
export class AuditChangesComponent implements OnInit {
  public page: IPageResult<IAuditChanges> = {
    items: [],
    total: 0,
  };

  constructor(private auditChangesService: AuditChangesService) {}

  ngOnInit() {
    var filter = this.getDefaultFilter();
    this.load(filter);
  }

  getDefaultFilter() {
    return <IAuditChangesFilter>{
      first: 0,
      rows: 10,
      sortField: 'dateTime',
      sortOrder: -1,
      filters: {},
    };
  }

  load(filterCommand: IAuditChangesFilter) {
    console.log(filterCommand);
    this.auditChangesService.getPage(filterCommand).then((result) => {
      this.page = result;
    });
  }

  // onGridLazyLoad(event: LazyLoadEvent) {
  //     var filter = this.getDefaultFilter();
  //     filter.first = event.first;
  //     filter.rows = event.rows;
  //     if (event.sortField) filter.sortField = event.sortField;
  //     filter.sortOrder = event.sortOrder;

  //     this.load(filter);
  // }
}
